import {
    validateFlowContextContract,
    validateGenerationIrContract
} from "./contracts.js";
import { buildFlowSummaryFromContext } from "./summary.js";
import {
    extractFlowNodesFromSnapshot,
    extractFlowAxesFromProject,
    extractFlowConditionsFromSnapshot,
    extractFlowErrorsFromSnapshot,
    buildFlowContextFromSources
} from "./context.js";
import {
    buildGenerationGraphIrFromContext,
    buildGenerationIrFromContext
} from "./ir.js";
import {
    buildAiPromptFromSnapshot,
    buildLocalSummaryResponseFromSnapshot,
    buildLocalReviewResponseFromSnapshot,
    buildLocalStResponseFromDraft,
    buildLocalStBlockedResponse
} from "./prompt.js";
import { buildLocalStDraftFromSnapshot } from "./st-draft.js";

export const GENERATION_FACADE_KEYS = Object.freeze([
    "validateFlowContextContract",
    "validateGenerationIrContract",
    "buildFlowSummaryFromContext",
    "extractFlowNodesFromSnapshot",
    "extractFlowAxesFromProject",
    "extractFlowConditionsFromSnapshot",
    "extractFlowErrorsFromSnapshot",
    "buildFlowContextFromSources",
    "buildGenerationGraphIrFromContext",
    "buildGenerationIrFromContext",
    "buildAiPromptFromSnapshot",
    "buildLocalSummaryResponseFromSnapshot",
    "buildLocalReviewResponseFromSnapshot",
    "buildLocalStDraftFromSnapshot",
    "buildLocalStResponseFromDraft",
    "buildLocalStBlockedResponse",
    "getFlowContext",
    "getGenerationIr",
    "getGenerationSnapshot",
    "requestGeneration",
    "exportFlowContext",
    "exportGenerationIr"
]);

export const GENERATION_RUNTIME_KEYS = Object.freeze([
    "getFlowContext",
    "getGenerationIr",
    "getGenerationSnapshot",
    "requestGeneration",
    "exportFlowContext",
    "exportGenerationIr"
]);

export function validateGenerationRuntimeKeys(runtime = {}) {
    const expected = [...GENERATION_RUNTIME_KEYS].sort();
    const actual = Object.keys(runtime || {}).sort();
    if (expected.length !== actual.length) return false;
    for (let i = 0; i < expected.length; i += 1) {
        if (expected[i] !== actual[i]) return false;
    }
    return true;
}

export function createGenerationFacade(runtime = {}) {
    const facade = {
        validateFlowContextContract,
        validateGenerationIrContract,
        buildFlowSummaryFromContext,
        extractFlowNodesFromSnapshot,
        extractFlowAxesFromProject,
        extractFlowConditionsFromSnapshot,
        extractFlowErrorsFromSnapshot,
        buildFlowContextFromSources,
        buildGenerationGraphIrFromContext,
        buildGenerationIrFromContext,
        buildAiPromptFromSnapshot,
        buildLocalSummaryResponseFromSnapshot,
        buildLocalReviewResponseFromSnapshot,
        buildLocalStDraftFromSnapshot,
        buildLocalStResponseFromDraft,
        buildLocalStBlockedResponse,
        getFlowContext: runtime.getFlowContext,
        getGenerationIr: runtime.getGenerationIr,
        getGenerationSnapshot: runtime.getGenerationSnapshot,
        requestGeneration: runtime.requestGeneration,
        exportFlowContext: runtime.exportFlowContext,
        exportGenerationIr: runtime.exportGenerationIr
    };
    return facade;
}
